const e = "19.0.0-next.8";
export {
  e as RgThreeVersion
};
//# sourceMappingURL=index2.js.map
